import React from 'react';
import dcgLogo from '../../../assets/img/brand/dcg_logo_header.png';
import { SectionDivider, PageTitle, HeaderAndBodyLayout } from '../../../utilities/dcgAutomationPageCommonImports';
import CreateSubscriptionPageContent from '../PageContent/CreateSubscriptionPageContent';

const CreateSubscription = () => {
    return (
        <HeaderAndBodyLayout headerLogo={dcgLogo} containerSize="md">
            <PageTitle
                heading="Create your subscription" subheading="Each device requires a license to get started. How many devices will you have?"
            />
            <SectionDivider width="50%" />
            <CreateSubscriptionPageContent />
        </HeaderAndBodyLayout>
    );
};

export default CreateSubscription;